<template>
  <v-container fluid>
    <h2> {{assessmenType.name}} - Questions</h2>

    <v-card-title>
      <div class="my-2">
        <!-- <v-btn small disabled>Disabled</v-btn> -->
        <v-btn v-if="loggedRoleId == 2" @click="newAssessment()" color="primary">CREATE</v-btn>
      </div>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="SEARCH"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="assessments"
      :search="search"
      item-key="name"
      class="elevation-1"
      @click:row="editRowClick"
    >
      <template v-slot:[`item.updatedOn`]="{ item }">
        <span>{{moment(item.updatedOn).format('MM-DD-YYYY') }}</span>
      </template>
    </v-data-table>

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <!-- <template v-slot:activator="{ on, attrs }">
          <v-btn
            bottom
            color="pink"
            dark
            fab
            fixed
            right
            v-bind="attrs"
            v-on="on"
            @click="newAssessment()"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>-->

        <v-card>
          <v-card-title>
            <span class="headline">Question</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form">
                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      label="Assessment Name"
                      :rules="requiredField"
                      v-model="dialogItem.assessmentName"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="dialogItem.lowRatingName"
                      label="Low rating"
                      hint="Brief low rating description"
                      persistent-hint
                      :rules="requiredField"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="dialogItem.highRatingName"
                      label="High Rating"
                      hint="Brief High rating description"
                      persistent-hint
                      :rules="requiredField"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-switch v-model="dialogItem.active" class="ma-2" label="Active?"></v-switch>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <!-- <small>*indicates required field</small> -->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
            <div v-if="dialogItem.assessmentId > 0">
              <v-btn color="blue darken-1" text @click="updateAssessment()">update</v-btn>
            </div>
            <div v-else>
              <v-btn color="blue darken-1" text @click="saveAssessment()">Save</v-btn>
            </div>
            <!-- <v-btn color="blue darken-1" text @click="saveAssessment()">Save</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable no-debugger */
export default {
  data: () => ({
    search: "",
    assessmenType:{},
    assessments: [],
    headers: [
      {
        text: "ID",
        align: "start",
        sortable: false,
        value: "assessmentId",
      },
      { text: "QUESTION", value: "assessmentName" },
      { text: "LOW RATING", value: "lowRatingName" },
      { text: "HIGH RATING", value: "highRatingName" },
      { text: "ACTIVE", value: "active" },
      { text: "UPDATED BY", value: "updatedBy" },
      { text: "UPDATED ON", value: "updatedOn" },
    ],
    dialog: false,
    dialogItem: {
      assessmentName: "",
      assessmentId: 0,
      lowRatingName: "",
      highRatingName: "",
      active: true,
      rate: 0,
    },
    tempItem: {},
    requiredField: [
      (v) => !!v || "This field is required",
      (v) => v.length >= 3 || "Minimum length is 3 characters",
    ],
  }),
  methods: {
    editRowClick(item) {
      this.tempItem = item;
      this.dialogItem = JSON.parse(JSON.stringify(item));
      this.dialog = true;
      console.log(item);
    },
    newAssessment() {
      this.dialogItem = {
        assessmentName: "",
        lowRatingName: "",
        highRatingName: "",
        assessmentId: 0,
        active: true,
        rate: 0,
        assessmentTypeId:this.$route.query.assessmentTypeId
        
      };
      this.dialog = true;
      console.log(this.dialogItem);
    },
    saveAssessment() {
      //OID20002
      if (this.$refs.form.validate()) {
        const baseURI = this.$store.getters.getBaseUrl + "assessment";
        this.$http
          .post(baseURI, this.dialogItem)
          .then((result) => {
            console.log(result.data);
            this.assessments.push(result.data);
            this.dialog = false;
          })
          .catch(function (error) {
            console.log("error " + error);
            alert("error" + error.response.data);
          });
        console.log("you click save assessment");
      }
    },
    updateAssessment() {
      //OID20002
      if (this.$refs.form.validate()) {
        
        this.tempItem.assessmentName = this.dialogItem.assessmentName;
        this.tempItem.lowRatingName = this.dialogItem.lowRatingName;
        this.tempItem.highRatingName = this.dialogItem.highRatingName;
        this.tempItem.assessmentId = this.dialogItem.assessmentId;
        this.tempItem.active = this.dialogItem.active;
        this.tempItem.rate = this.dialogItem.rate;
        this.tempItem.updatedBy = this.$store.getters.getUsername;
        this.tempItem.updatedOn = this.moment().format("MM-DD-YYYY");

        this.$http
          .post(this.$store.getters.getBaseUrl + "assessment", this.dialogItem)
          .then(() => {
            this.dialog = false;
          })
          .catch(function (error) {
            console.log("error " + error);
            alert("error" + error.response.data);
          });
      }
    },
  },
  mounted() {
    console.log("run mounted");
     //OID20001
      var assessmentTypeId = (this.$route.query.assessmentTypeId == null) ? 0:this.$route.query.assessmentTypeId     
      this.assessmenType = this.$store.getters.getSelectedAssessmentType;      
      //debugger
      this.$http
      .get(this.$store.getters.getBaseUrl + "assessment/?assessmentTypeId="+assessmentTypeId)
      .then((result) => {
        this.assessments = result.data;
        //debugger
      })
      .catch(function (error) {
        console.log("error " + error);
        alert("error" + error.response.data);
      });
  },
   computed:{
     loggedRoleId() {
      return this.$store.getters.getRoleId;
    }
  }
};
</script>